export default () => {
	const uspItems = document.querySelectorAll('.footer__usp-item');
	const USP_ACTIVE_CLASS = 'footer__usp-item--active';
	const USP_DELAY = 1500;

	// items slider
	if (uspItems.length) {
		setInterval(() => {
			const activeItem = document.querySelector('.footer__usp-item--active');
			const nextItem = activeItem.nextElementSibling;
			const firstItem = document.querySelector('.footer__usp-item:first-child');

			activeItem.classList.remove(USP_ACTIVE_CLASS);
			if (nextItem) {
				nextItem.classList.add(USP_ACTIVE_CLASS);
			} else {
				firstItem.classList.add(USP_ACTIVE_CLASS);
			}
		}, USP_DELAY);
	}
}
